<template>
  <div class="page-header">
    <div class="page-title">
      <h4>
        {{ title }} <span class="count-details">{{ text }}</span>
      </h4>
    </div>
    <div class="page-btn">
      <ul>
        <li>
          <a href="javascript:;" class="btn btn-white comman-file file-pdf">
            <i class="bx bxs-file-pdf"></i
          ></a>
        </li>
        <li>
          <a href="javascript:;" class="btn btn-white comman-file file-text">
            <i class="bx bxs-file"></i
          ></a>
        </li>
        <li>
          <a href="javascript:;" class="btn btn-white center-flex">
            <i class="bx bx-import me-1"></i>{{ text1 }}</a
          >
        </li>
        <li v-if="isUsersRoute">
          <a
            href="javascript:;"
            class="btn btn-added center-flex"
            data-bs-toggle="modal"
            data-bs-target="#add-users"
          >
            <i class="bx bx-plus-circle me-1"></i>{{ text2 }}</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    text1: {
      type: String,
      default: "",
    },
    text2: {
      type: String,
      default: "",
    },
  },
  computed: {
    isUsersRoute() {
      return this.$route.path === "/users";
    },
  },
};
</script>
